// Datawrapper's embed sets min-width: 100% !important and a short height.
// innerHTML does not run the embed's resize script, so listen for the
// chart's own height message and let the map fill the card width.
const FALLBACK_HEIGHT = 780

export function mountConnectionMap(container, embedCode) {
	if (!container) return
	if (container._dwResize) {
		window.removeEventListener("message", container._dwResize)
	}
	container.innerHTML = embedCode
	const iframe = container.querySelector("iframe")
	if (!iframe) return

	const src = iframe.getAttribute("src")
	iframe.removeAttribute("width")
	iframe.setAttribute("height", String(FALLBACK_HEIGHT))
	iframe.style.setProperty("width", "100%", "important")
	iframe.style.setProperty("max-width", "100%", "important")
	iframe.style.setProperty("min-width", "0", "important")
	iframe.style.setProperty("height", FALLBACK_HEIGHT + "px", "important")
	iframe.style.setProperty("border", "none", "important")
	iframe.style.setProperty("display", "block", "important")

	const onMessage = (event) => {
		const heights = event.data && event.data["datawrapper-height"]
		if (!heights || iframe.contentWindow !== event.source) return
		const reported = Object.values(heights)[0]
		if (!reported) return
		iframe.style.setProperty("height", reported + "px", "important")
	}
	container._dwResize = onMessage
	window.addEventListener("message", onMessage)

	if (src) {
		iframe.setAttribute("src", src)
	}
}
